export const ASTERX_DIVISION = 'AsterX'
export const HELP_DESK_DIVISION = 'Help desk'